import metaCache from "flow/utils/metaCache";
import { IComponentManifest } from "flow/manifests/ManifestInterfaces";

export default class ProductComponentManifestEx implements IComponentManifest {
    baseUrl: string;
    bundle: string;
    defaultParameters: object;
    id: string;
    isEmbedded: boolean = true;
    name: string;
    namespace: string;
    reuseInstance = false;
    tags: string[];
    useFormValidation: boolean = false;
    useValidationV3: boolean;
    view: string;
    viewModel: any;
    viewModelId: string;
    viewUrl: string;

    constructor(manifest: IComponentManifest, baseUrl: string) {
        this.baseUrl = baseUrl;
        this.bundle = manifest.bundle;
        this.defaultParameters = manifest.defaultParameters;
        this.id = manifest.id;
        this.name = metaCache.translate(manifest.name);
        this.namespace = manifest.namespace;
        this.tags = manifest.tags ? manifest.tags : [];
        this.useValidationV3 = manifest.useValidationV3;
        this.view = manifest.view ? manifest.view.trim() : undefined;
        this.viewModel = manifest.viewModel;
        this.viewModelId = manifest.viewModelId;
        this.viewUrl = manifest.viewUrl;
    }
}
